import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './BiayaPensiun.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'
import Utils from '../../../libs/custom/Utils'

var _baseId = "mod-table-biaya-pensiun"

const BiayaPensiunTable = ({
  className       = '',
  showCommandbar  = true,
  history
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title={t.translate('modules.biayaPensiun.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="createdDate"
      columns={[
        {
          label: 'Mulai Berlaku (Tahun)',
          searchable: true,
          key: 'tahunMulaiBerlaku',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tahunMulaiBerlaku)
        },{
          label: 'Sampai Berlaku (Tahun)',
          searchable: true,
          key: 'tahunAkhirBerlaku',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tahunAkhirBerlaku)
        },{
          label: 'Tarif (%)',
          searchable: true,
          key: 'tarif',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tarif)
        },{
          label: 'Sebulan (Rp)',
          searchable: true,
          key: 'sebulan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.sebulan))
        },{
          label: 'Setahun (Rp)',
          searchable: true,
          key: 'setahun',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.setahun))
        },{
          label: 'Keterangan',
          searchable: true,
          key: 'keterangan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.keterangan)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/biaya-pensiun/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/biaya-pensiun/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default BiayaPensiunTable
